import React from 'react'

const Pagenotfound = () => {
  return (
    <div><h1>OOps ! Pagenotfound</h1></div>
  )
}

export default Pagenotfound